<template>
<div>
  <h1 class="title">Draw test</h1>
  <handwrite-input
    v-model="imageData"
    :canvas-height-default="300"
  ></handwrite-input>
</div>
</template>
<script>
import HandwriteInput from '@/components/molecules/HandwriteInput'

export default{
  name: 'DrawTest',

  components: {
    HandwriteInput,
  },

  watch: {
    //imageData(val) {
    //  console.log(val);//!!!!!!
    //},
  },

  data(){
    return {
      imageData: '',
    }
  },

  mounted() {
  },

  methods: {
  },
}
</script>
